import { Box } from "@mui/system";
import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import DocCards from "./components/DocCards";
import DocFilter from "./components/DocFilter";
import DocTable from "./components/DocTable";
import PageHeader from "@/components/common/PageHeader";
import { AppDispatch } from "@/app/store";
import { fetchDocumentsWithFilters } from "@/features/documents/documentsThunks";
import { useDocumentFilters } from "./hooks/useDocumentFilters";

const DocumentsPage: FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { filters, applyFilters } = useDocumentFilters();

    useEffect(() => {
        dispatch(fetchDocumentsWithFilters({}));
    }, [dispatch]);

    return (
        <Box sx={{
            backgroundColor: 'background.default',
            px: { xs: 2, md: 3, lg: 4 }
        }}>
            <PageHeader title="Administrador de Documentos" description="Plataforma digital que centraliza toda la documentación del colegio, garantizando acceso rápido y seguro según tu perfil de usuario." />
            <DocCards />
            <DocFilter filters={filters} onApply={applyFilters} />
            <DocTable />
        </Box>
    );
};

export default DocumentsPage;